const DeveloperTypeTypes = {
  developer: "Застройщик",
  operating: "Эксплуатирующая организация",
  regional: "Региональный оператор",
} as const;

export const participantTableFactory = (participant: any) => {
  return [
    {
      id: 1,
      title: "Тип",
      info: participant?.developerType
        ? DeveloperTypeTypes[participant.developerType as keyof typeof DeveloperTypeTypes]
        : "",
    },
    { id: 2, title: "ИНН", info: participant?.company?.inn },
    { id: 3, title: "КПП", info: participant?.company?.kpp },
    { id: 4, title: "ОГРН", info: participant?.company?.ogrn },
    {
      id: 5,
      title: "Контакты",
      info: `${participant?.company?.contacts?.email ?? ""} ${participant?.company?.contacts?.phone ?? ""}`.trim(),
    },
    {
      id: 6,
      title: "Адрес",
      info: participant?.company?.addresses?.legal?.fullAddress,
    },
  ];
};
